import i18n from './../../shared/i18n';

import BaseModel from "../../core/components/input-widget/BaseModel";

export default class TransferNoteItemModel extends BaseModel {
  inventory_uuid = null;
  new_item_location_uuid = null;
  fao = null
  ordering = null
  tableIndex = null
  uuid = null

  constructor(data = {}) {
    super();

    Object.assign(this, {...data});
  }

  toJSON() {
    const data = super.toJSON();

    if (data.new_item_location_uuid === undefined) {
      data.new_item_location_uuid = null
      delete data.new_item_location
    }

    return data
  }

  rules = {
    inventory_uuid: 'required'
  };

  attributeHints = {
  };

  attributeLabels = {
    inventory_uuid: i18n.t('Inventory'),
    new_item_location_uuid: i18n.t('New Item Location'),
    fao: i18n.t('FAO'),
  };
}
